import React from 'react';
import { observer } from 'mobx-react';

import { constants } from '../../../config';
import { HomeNavbar } from '../../../common/home-navbar';
import { ProductTable } from '../../cart/product-table';
import { Footer } from '../../../common/footer';
import { Spinner } from '../../../common/spinner';
import { MyAccountMenu } from '../my-account-menu';
import { CartStore } from '../../../stores/CartStore';
import { SessionStore } from '../../../stores/SessionStore';
import { ScreenStore } from '../../../stores/ScreenStore';
import { USER_TYPES } from '../../../models/User';
import { routeNaming, AppRedirect, AppLink } from '../../../routes';
import styles from './MyFavorites.css';
import { SEO } from '../../../common/seo';

const MyFavorites = observer(class MyData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    SessionStore.getUser();
  }

  componentWillUnmount() {
    SessionStore.resetEditUserErrors();
  }

  render() {
    if (!SessionStore.loggedIn) {
      return (
        <AppRedirect routeName={routeNaming.HOME} />
      );
    }

    const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.extraSmallMaxWidth;

    return (
      <div className={styles.container}>
        <SEO
          title="Favoritos"
          type="website"
        />
        <HomeNavbar />
        <div className={styles.mainContent}>
          {
            !mobileVersion &&
            <div className={styles.titleContainer}>
              <h1 className={styles.title}>Mi Cuenta</h1>
              <h2 className={styles.subtitle}>
                <span>Hola, </span>
                {SessionStore.user.type === USER_TYPES.COMPANY ?
                  SessionStore.user.fictitiousName :
                  SessionStore.user.names}
                !
              </h2>
            </div>
          }
          {
            mobileVersion &&
            <p className={styles.breadcrumb}>
              <AppLink
                className={styles.breadcrumb}
                routeName={routeNaming.MY_ACCOUNT_MENU_MOBILE}
              >
                Mi Cuenta
              </AppLink>
              <span> &gt; Mis Datos</span>
            </p>
          }
          <div className={styles.content}>
            {
              !mobileVersion && <MyAccountMenu indexSelectedItem={5} />
            }
            <div className={styles.myDataContainer}>
              <div className={styles.headerContainer}>
                <h2 className={styles.header}>
                  Favoritos
                </h2>
              </div>
              <div>
                {
                  !CartStore.isFetchingFavorites &&
                  <ProductTable isCart={false} />
                }
                {
                  CartStore.isFetchingFavorites &&
                  <Spinner className={styles.cartSpinner} />
                }
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
});

export { MyFavorites };



// WEBPACK FOOTER //
// ./src/pages/my-account/my-favorites/MyFavorites.jsx